import { atom } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ConformedCampaignFeedAd, feedAdDefaultMeta, MediaAsset } from '../../views'

export const [feedAdAtom, useFeedAdListener] = atomWithListeners<ConformedCampaignFeedAd | undefined>(
	undefined,
)

export const feedAdStatusAtom = atom<LifecycleState>('idle')
export const feedAdSavingAtom = atom<PersistenceState>('idle')

export const feedAdImageHistoryAtom = atom<Array<MediaAsset>>([])
export const feedAdHasGeneratedContentAtom = atom(false)
export const feedAdAiImageryDetectedAtom = atom(false)

// Focus atoms

export const feedAdTitleAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('title'))
export const feedAdSubtitleAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('subtitle'))
export const feedAdLocationAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('location'))
export const feedAdPrimaryTextAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('primaryText'))
export const feedAdHeadlineTextAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('headlineText'))
export const feedAdDescriptionTextAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('descriptionText'))
export const feedAdCtaTextAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('ctaText'))
export const feedAdMetaCtaTextAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('metaCtaText'))
export const feedAdImageIdAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('imageId'))

export const feedAdMetaAtom = focusAtom(feedAdAtom, (optic) => optic.optional().prop('meta'))

// backdrop
export const feedAdMetaLogoBackgroundFillColorAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('logoBackgroundFillColor'),
)
export const feedAdMetaOverlayAtom = focusAtom(feedAdMetaAtom, (optic) => optic.optional().prop('backdropOverlay'))
export const feedAdMetaBackdropOverlayProModeAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('backdropOverlayProMode'),
)
export const feedAdMetaBackdropTransformAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('backdropTransform'),
)

// content
export const feedAdMetaGeneralContentAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('generalContent'),
)
export const feedAdMetaGeneralContentPaddingAtom = focusAtom(
	feedAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('globalPadding'),
)
export const feedAdMetaGeneralContentFontFamilyOverrideAtom = focusAtom(
	feedAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('globalFontFamilyOverride'),
)
export const feedAdMetaGeneralContentHideAtom = focusAtom(
	feedAdMetaGeneralContentAtom,
	(optic) => optic.optional().prop('hide'),
)

export const feedAdMetaCardsAtom = focusAtom(feedAdMetaAtom, (optic) => optic.optional().prop('cards'))

// positioning
export const feedAdMetaPositioningAtom = focusAtom(feedAdMetaAtom, (optic) => optic.optional().prop('positioning'))
export const feedAdMetaLogoPositionAtom = focusAtom(feedAdMetaPositioningAtom, (optic) => optic.optional().prop('logo'))
export const feedAdMetaLocationPositionAtom = focusAtom(
	feedAdMetaPositioningAtom,
	(optic) => optic.optional().prop('location'),
)
export const feedAdMetaAttributionPositionAtom = focusAtom(
	feedAdMetaPositioningAtom,
	(optic) => optic.optional().prop('attribution'),
)
export const feedAdMetaStackOrientationAtom = focusAtom(
	feedAdMetaPositioningAtom,
	(optic) => optic.optional().prop('stackOrientation'),
)

// title text
export const feedAdMetaTitleTextLayerAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('titleTextLayer'),
)
export const feedAdMetaTitleTextTransformAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('titleTextTransform'),
)

// subtitle text
export const feedAdMetaSubtitleTextLayerAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('subtitleTextLayer'),
)
export const feedAdMetaSubtitleTextTransformAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('subtitleTextTransform'),
)

export const feedAdMetaForceAiGeneratedLabelAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('forceAiGeneratedLabel'),
)

// canvas
export const feedAdMetaCanvasEnabledAtom = focusAtom(feedAdMetaAtom, (optic) => optic.optional().prop('canvasEnabled'))
export const feedAdCanvasLoadCounterAtom = atom(0)
export const feedAdMetaCanvasDocumentAtom = focusAtom(
	feedAdMetaAtom,
	(optic) => optic.optional().prop('canvasDocument'),
)
